const HEX_COLOR_PATTERN = /^#[0-9a-f]{6}$/i;

// Render-time safety floors, used only when a stored value is missing or invalid.
const SECTION_OVERLAY_OPACITY_FALLBACK = 50;
const SECTION_OVERLAY_COLOR_FALLBACK = '#000000';

function clampOpacity(value: number): number {
  if (!Number.isFinite(value)) return SECTION_OVERLAY_OPACITY_FALLBACK;
  return Math.max(0, Math.min(100, Math.round(value)));
}

export function parseSectionOverlayOpacity(value: unknown): number {
  if (typeof value === 'number') {
    return clampOpacity(value);
  }
  if (typeof value === 'string') {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) {
      return clampOpacity(parsed);
    }
  }
  return SECTION_OVERLAY_OPACITY_FALLBACK;
}

export function parseSectionOverlayColor(value: unknown): string {
  if (typeof value === 'string' && HEX_COLOR_PATTERN.test(value)) {
    return value;
  }
  return SECTION_OVERLAY_COLOR_FALLBACK;
}
